import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'skcpns'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const skcpnsList = 'Kepegawaian/SKCPNS/list/'
export const skcpnsCreate = 'Kepegawaian/SKCPNS/create/'
export const skcpnsDetail = 'Kepegawaian/SKCPNS/detail/'
export const skcpnsUpdate = 'Kepegawaian/SKCPNS/update/'
export const skcpnsApprove = 'Kepegawaian/SKCPNS/approve/'
export const skcpnsInactive = 'Kepegawaian/SKCPNS/inactive/'
export const skcpnsActive = 'Kepegawaian/SKCPNS/active/'

export const skcpnsRankList = 'Kepegawaian/SKCPNS/rankList/'
export const skcpnsSignatories = 'Kepegawaian/Penghargaan/signatories/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}
